<template>
  <Header />
  <slot />
  <Footer />
</template>

<script setup>
  
</script>